import * as React from 'react';

import {
  CommunicationActionLink,
  CommunicationActionButton,
  CommunicationLayout,
  CommunicationPaymentIllustration,
} from '../../../../components/Communication';
import { IBasePaymentCommunicationProps } from '../../types';
import {
  PAYMENT_SUCCESS_ACTION,
  PAYMENT_SUCCESS_MESSAGE,
  PAYMENT_SUCCESS_PAYMENT_ID_PREPEND,
  PAYMENT_SUCCESS_TITLE,
} from './constants';

export interface IPaymentSuccess extends IBasePaymentCommunicationProps {
  onAction: () => void;
  href?: string;
  paymentId?: string;
}

export const PaymentSuccess: React.FC<IPaymentSuccess> = ({ paymentId, onAction, testId, href }) => {
  const action = href ? (
    <CommunicationActionLink href={href} onClick={onAction}>
      {PAYMENT_SUCCESS_ACTION}
    </CommunicationActionLink>
  ) : (
    <CommunicationActionButton onClick={onAction}>{PAYMENT_SUCCESS_ACTION}</CommunicationActionButton>
  );

  return (
    <CommunicationLayout
      image={<CommunicationPaymentIllustration />}
      title={PAYMENT_SUCCESS_TITLE}
      testId={testId}
      message={`${paymentId && `${PAYMENT_SUCCESS_PAYMENT_ID_PREPEND} ${paymentId}. `}${PAYMENT_SUCCESS_MESSAGE}`}
      action={action}
    />
  );
};

PaymentSuccess.displayName = 'PaymentSuccessContainer';
